// extracted by mini-css-extract-plugin
export default {"cls1":"y_FMAaFNSx5Wox7dlT0g","cls2":"AsDA0GEV_Ob8PaVzRSwx y_FMAaFNSx5Wox7dlT0g"};